import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Surface } from '@vst/beam';

import { useScreenResolution } from '@app/hooks';
import { selectStreamOn, selectUser, selectUtil, setStreamOnPageStatistics } from '@app/redux';

import { StreamOnStatus } from '@mfe/shared/schema-types';

import StreamCardBody from './body';
import StreamCardFooter from './footer';
import StreamCardHeader from './header';
import StreamCardLoading from './loading';

import styles from './styles.module.scss';

const StreamCard = (): JSX.Element | null => {
  const dispatch = useDispatch();
  const [streamOnStatus, setStreamOnStatus] = useState<StreamOnStatus>(StreamOnStatus.RequestErrored);
  const {
    user: {
      auth: { isAuthenticated },
    },
  } = useSelector(selectUser);
  const {
    pageStats: {
      pages: {
        streamOn: { lastUpdatedTime },
      },
    },
  } = useSelector(selectUtil);
  const { loading: streamOnLoading, streamOn } = useSelector(selectStreamOn);

  const { isMedium, isLarge, isExtraLarge } = useScreenResolution();
  const isDesktop = isMedium || isLarge || isExtraLarge;

  useEffect(() => {
    if (!lastUpdatedTime && isAuthenticated) {
      dispatch(setStreamOnPageStatistics());
    }
  }, [dispatch, isAuthenticated, lastUpdatedTime]);

  useEffect(() => {
    setStreamOnStatus(streamOn.status);
  }, [streamOn]);

  if (streamOnLoading) {
    return <StreamCardLoading />;
  }

  return (
    <Surface data-cy="stream-on-loaded" className={styles['streamOnCardStyle']} radius={isDesktop ? '16px' : '0px'}>
      <StreamCardHeader state={streamOnStatus} />
      <StreamCardBody state={streamOnStatus} />
      <StreamCardFooter state={streamOnStatus} />
    </Surface>
  );
};

export default StreamCard;
